import Swiper from "swiper";
import {Pagination} from "swiper/modules";
import 'swiper/css/bundle';
Swiper.use([Pagination]);

export default class MobileApp
{
    constructor() {
        this.initListeners();
    }

    initListeners() {
        const buttons = document.querySelectorAll('.app__button');
        if (buttons) {
            buttons.forEach((button) => {
                button.addEventListener('click', () => {
                    document.querySelector('.banner-citylink-app').scrollIntoView({
                        behavior: 'smooth'
                    });
                });
            })
        }

        document.addEventListener('DOMContentLoaded', (el) => {
            this.swiper = new Swiper('[js-mobile-app-swiper]', {
                spaceBetween: 20,
                slidesPerView: "auto",
                centeredSlides: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    768: { // when window width is >= 768px
                        slidesPerView: 3,
                        centeredSlides: false,
                        enabled: false
                    }
                },
                on: {
                    slideChange: function () {
                        let slideDescription = this.slides[this.realIndex].querySelector('.home-services__slide-description').innerHTML;
                        let slideTitle = this.slides[this.realIndex].querySelector('.home-services__slide-title').innerHTML;

                        document.querySelector('.home-services__mobile-slide-title').innerHTML = slideTitle;
                        document.querySelector('.home-services__mobile-slide-description').innerHTML = slideDescription;
                    }
                }
            })
        })
    }
}
